import { Box, Button, Icon, inputMediumStyles } from '@bechtel/gds';
import styled, { css } from 'styled-components';
import { SearchField } from '~/components/search-field';
export const SyncContainerStyled = styled(Box).attrs({ flexDirection: { sm: 'column' } })`
  height: 100vh;
`;
export const SyncHeaderStyled = styled(Box).attrs({ px: { sm: '500' }, pt: { sm: '600' }, pb: { sm: '550' } })`
  ${({ theme }) => css`
    background-image: linear-gradient(275deg, ${theme.colors.bechtel.blue[1000]}, ${theme.colors.bechtel.blue[800]});
  `}
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.2), 0 3px 3px -2px rgba(0, 0, 0, 0.12), 0 3px 4px 0 rgba(0, 0, 0, 0.14);
  z-index: 1;
`;

export const SearchFieldComponentStyled = styled(SearchField)`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes[300]};
    ::placeholder {
      color: ${theme.colors.grey[1000]};
    }
    :-ms-input-placeholder {
      color: ${theme.colors.grey[1000]};
    }
    ::-ms-input-placeholder {
      color: ${theme.colors.grey[1000]};
    }
  `}
  ${inputMediumStyles}
`;
export const PreStyle = {
  margin: 0,
  whiteSpace: 'pre-wrap',
  fontSize: 12,
  lineHeight: 1.5
};

export const IconStyled = styled(Icon)`
cursor: pointer;
margin-right: 8px;
opacity:0;

`
export const TableCellStyled = styled(Box)`
&:hover .icon {
    opacity: 1;
  }
`
export const IconBoxStyled=styled(Box)`
width:20px;
height:20px;
background-color:white;
display:flex;
justify-content:center;
align-items:center
`

export const JsonStyledBox = styled(Box).attrs({
  p: { sm: '400' }
})`
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden; 
  padding: 20px;
`

export const FooterStyled = styled(Box).attrs({
  p: { sm: '400' },
  justifyContent: { sm: 'flex-end' },
  pl: { sm: '500' },
})`
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0 -3px 6px 0 rgba(0, 0, 0, 0.16);
`;

export const FooterButtonStyled = styled(Button)`
  ${({ theme }) => css`
    width: auto;
    background-color: ${theme.colors.primary[700]};
    padding: ${theme.spacings[300]} ${theme.spacings[600]};
    margin-right: ${theme.spacings[400]};
    white-space: nowrap;
  `}
`;

export const TableStyled = styled.table`
  text-align: left;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  ${({ theme }) => css`
    td,
    th {
      border: 1px solid ${theme.colors.grey[300]};
      padding: ${theme.spacings[400]};
    }
    th {
      background-color: ${theme.colors.grey[100]};
      z-index: 1;
      vertical-align: middle;
    }
    td {
      background-color: ${theme.colors.white};
      z-index: 0.9;
    }
    tr td:last-child,
    tr th:last-child {
      position: sticky;
      right: 0;
      top: 0;
    }
    tr th:last-child div {
      justify-content: center;
    }
    tr td:last-child div {
      justify-content: center;
      cursor: pointer;
    }
  `}
`;
interface TableHeaderStickyStyledProps {
  widthExpanded?: boolean;
}
const getColumnWidth = (props: TableHeaderStickyStyledProps)  => {

  return css`
    max-width:210px;
    min-width:${props.widthExpanded?'210px':'110px'};
  `;
};


export const TableHeaderStickyStyled = styled.th<TableHeaderStickyStyledProps>`
  position: sticky;
  top: 0;
  left: 0;
  vertical-align: top;
  ${props=>getColumnWidth(props)}
`;

export const SubContainerStyled = styled(Box).attrs({
  mt: { sm: '400' },
  ml: { sm: '400' },
  mr: { sm: '300' },
  flexDirection: { sm: 'column' },
})`
  height: 100vh;
  background-color: ${({ theme }) => theme.colors.white};
  border-top-left-radius: ${({ theme }) => theme.radii[200]};
  border-top-right-radius: ${({ theme }) => theme.radii[200]};
  overflow-y: auto;
  position: relative;
`;

export const ItemsContainerStyled = styled(Box).attrs({
  mt: { sm: '500' },
  flexDirection: { sm: 'column' },
})`
  ${() => css`
    height: calc(100vh - 207px);
    overflow-y: auto;
  `};
`;

export const TableColumnStyled = styled.td`
  ${getColumnWidth};
`;
export const ErrorDetailsHeaderStyled = styled(Box).attrs({
  pl: { sm: '500' },
  py: { sm: '400' },
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'space-between' },
})`
  background-color: ${({ theme }) => theme.colors.primary[700]};
`;
